/*
  *******************
      注册全局组件
  *******************
*/
import Vue from 'vue'

import layoutContainer from '~/components/layout/container'

Vue.component('layoutContainer', layoutContainer)



// WEBPACK FOOTER //
// ./src/utils/components.js